import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from 'react-apollo';
import { BrowserRouter } from 'react-router-dom';
import { client } from './client';
import { ThemeProvider, createTheme } from '@material-ui/core';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import './assets/styles.css';
import 'react-image-lightbox/style.css';
import { MainRoutes } from './MainRoutes';
import { ModalProvider } from './context/ModalContext';

const HEADING_COLOR = '#34404E';
const BODY_COLOR = '#57646F';

export const bokunTheme = {
    primary: '#1D57C7',
    light: '#f1f5fc',
    red: '#e60000',
    chart: {
        negative: '#CC529B',
    },
};

const theme = createTheme({
    shape: {
        borderRadius: 12,
    },
    overrides: {
        MuiButton: {
            root: {
                textTransform: 'none',
                fontWeight: 'bold',
                borderRadius: 24,
            },
        },
    },
    palette: {
        background: {
            default: '#fff',
        },
        primary: {
            main: bokunTheme.primary,
        },
        secondary: {
            main: '#57616D',
        },
        info: {
            main: '#363A3F',
        },
    },
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        body1: {
            color: BODY_COLOR,
        },
        body2: {
            color: BODY_COLOR,
        },
        h1: {
            color: HEADING_COLOR,
        },
        h2: {
            color: HEADING_COLOR,
        },
        h3: {
            color: HEADING_COLOR,
        },
        h4: {
            color: HEADING_COLOR,
        },
        h5: {
            color: HEADING_COLOR,
        },
        h6: {
            color: HEADING_COLOR,
        },
    },
});

ReactDOM.render(
    <ApolloProvider client={client}>
        <ThemeProvider theme={theme}>
            <StyledThemeProvider theme={bokunTheme}>
                <BrowserRouter>
                    <ModalProvider>
                        <MainRoutes />
                    </ModalProvider>
                </BrowserRouter>
            </StyledThemeProvider>
        </ThemeProvider>
    </ApolloProvider>,
    document.getElementById('root')
);
